import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/auth';
import { ReminderModel } from '../../pages/reminders/RemindersIndex';
import api from '../../services/api';
import EstimateReminder from './EstimateReminder';

interface EstimateRemidersProps {
  estimateId: number;
}

export type EstimateReminderModel = {
  id?: number;
  estimateId: number;
  reminderId: number;
  reminderAt?: string;
  processedAt?: string;
  description: string;
  isRequired: boolean;
};

export default function EstimateRemiders({
  estimateId,
}: EstimateRemidersProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [activesReminders, setActivesReminders] = useState(
    [] as ReminderModel[]
  );
  const [estimateReminders, setEstimateReminders] = useState(
    [] as EstimateReminderModel[]
  );
  const [reminders, setReminders] = useState([] as EstimateReminderModel[]);

  const {
    user: { organization },
  } = useAuth();

  const getEstimateReminders = async () => {
    if (organization) {
      setIsLoading(true);
      const { data } = await api.get(
        `organizations/${organization.id}/estimates/${estimateId}/reminders`
      );
      setEstimateReminders(data.data || []);
      setIsLoading(false);
    }
  };

  const getReminders = async () => {
    if (organization) {
      setIsLoading(true);
      await getEstimateReminders();
      const { data } = await api.get(
        `organizations/${organization.id}/reminders/actives`
      );
      setActivesReminders(data.data);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const estimateRemindersList: EstimateReminderModel[] = activesReminders.map(
      (r) => {
        const estimateReminder = estimateReminders.find(
          (e) => e.reminderId === r.id
        );
        if (estimateReminder) {
          return {
            id: estimateReminder.id,
            estimateId,
            reminderId: estimateReminder.reminderId,
            reminderAt: estimateReminder.reminderAt,
            description: estimateReminder.description,
            processedAt: estimateReminder.processedAt,
            isRequired: r.isRequired,
          };
        }

        return {
          estimateId,
          reminderId: r.id,
          description: r.description,
          isRequired: r.isRequired,
        };
      }
    );

    setReminders(estimateRemindersList);
  }, [activesReminders]);

  useEffect(() => {
    getReminders();
  }, [organization]);

  return (
    <div className='row'>
      {reminders.length > 0 ? (
        reminders.map((item) => (
          <div key={item.reminderId} className='col-md-4 mb-1'>
            <EstimateReminder
              estimateId={estimateId}
              reminder={item}
              refreshReminders={getReminders}
            />
          </div>
        ))
      ) : (
        <span> </span>
      )}
    </div>
  );
}
